export default __webpack_public_path__ + "static/media/4x.eb817377.svg";